import React from 'react'
import $ from 'jquery'
import {
  Chart,
  ChartLegend,
  ChartSeries,
  ChartSeriesItem
} from '@progress/kendo-react-charts';


class SmallPie extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      series: [],
      paidataseries:""
    }
  }

  /* Esta é a primeira etapa após o construxctor para carregar este componente  */

  componentDidMount() {
    this.updateSeries()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.date !== this.props.date) {
      this.updateSeries()
    }
  }

  updateSeries = () => {
    let total = 0;
    if(this.props.fullPieData){
      this.props.fullPieData.map(_pie => {
        total+= parseInt(_pie.value)
      })
    }
    let series = [
      { value: total - this.props.data },
      { value: this.props.data }
    ]
    this.setState({ series})
  }

  render() {
    return (
      <div className="smallpie">
        <Chart >
          <ChartLegend />
          <ChartSeries>
            <ChartSeriesItem type="pie" data={this.state.series} />
          </ChartSeries>
        </Chart> 
      </div>
    )
  }
}
export default SmallPie;